import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidKeySkeletonAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m20.3 5.1 1.4-1.4c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L9.8 12.8C9 12.3 8 12 7 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5c0-1-.3-2-.8-2.8l4.9-4.9 1.4 1.4c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-1.4-1.4 1.4-1.4 1.4 1.4c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-1.4-1.4ZM7 20c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3Z"/>
  </SvgIcon>
}

export default SolidKeySkeletonAltIcon
